import styled from 'styled-components';

export const HeaderStyled = styled.div`
  padding: ${props => props.theme.size.rap};
  font-size: ${props => props.theme.font.h3};
  font-weight: bold;
`;
